// PACKAGES/ HOOKS
import React, { useState, useEffect } from "react"
import { useAppDispatch } from "hooks"
// COMPONENTS
import EscalationForm from "./EscalationForm"
import EscalationsTable from "./EscalationsTable"
// SLICE/CONTEXT
import EscalationContext from "./EscalationContext"
import { getLocationEscalationsByLocationId } from "store/Location/locationEscalations.slice"
// UTILS/CONSTANTS
import { GetLocationEscalationsInterface } from "@type/locations.types"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useLocationScheduleDefaults } from "hooks/useScheduleDefaults"

const LocationEscalations: React.FC = () => {
	const dispatch = useAppDispatch()
	useLocationScheduleDefaults()

	const [locationEscalation, setLocationEscalation] = useState<GetLocationEscalationsInterface | null>(null)

	const { selectedLocation = "" } = useSchedulesQueryParams()

	const handleLocationEscalationHandler = (escalations: GetLocationEscalationsInterface | null) => {
		setLocationEscalation(escalations)
	}

	useEffect(() => {
		selectedLocation && dispatch(getLocationEscalationsByLocationId(selectedLocation))
	}, [selectedLocation])

	return (
		<>
			<EscalationContext.Provider value={{ locationEscalation, handleLocationEscalationHandler }}>
				<EscalationForm />
				<EscalationsTable />
			</EscalationContext.Provider>
		</>
	)
}

export default LocationEscalations
